<template>
  <div class="form-grid" :style="gridStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormGrid',
  props: {
    defaultSpan: {
      type: Number,
      default: 6,
      validator: (value) => value >= 1 && value <= 12
    }
  },
  computed: {
    gridStyle() {
      return { '--form-grid-default-span': this.defaultSpan }
    }
  }
}
</script>

<style scoped>
.form-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: var(--sid-space-4);
  min-width: 0;
}

.form-grid :deep(> *) {
  min-width: 0;
  grid-column: span var(--form-grid-span, var(--form-grid-default-span));
}

@media (max-width: 1023px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .form-grid :deep(> *) {
    grid-column: span var(--form-grid-tablet-span, 1);
  }
}

@media (max-width: 599px) {
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .form-grid :deep(> *) {
    grid-column: 1;
  }
}
</style>
